import Vue from 'vue'
import Router from 'vue-router'
import {routerMode} from '../config/env'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/index',
      name: 'index',
      component: r => require.ensure([], () => r(require('@/view/home/index')), 'index'),
      meta: {
        requireLogin: true
      }
    },
    {
      path: '/',
      name: 'login',
      component: r => require.ensure([], () => r(require('@/view/ucenter/login')), 'login'),
    },
    {
      path: '/register',
      name: 'register',
      component: r => require.ensure([], () => r(require('@/view/ucenter/register')), 'register'),
    },
    {
      path: '/data',
      name: 'data',
      component: r => require.ensure([], () => r(require('@/view/data/index')), 'index'),
      meta: {
        requireLogin: true,
      }
    },
    {
      path: '/call',
      name: 'call',
      component: r => require.ensure([], () => r(require('@/view/data/call-detail/index')), 'call'),
      meta: {
        requireLogin: true
      }
    },
    {
      path: '/push',
      name: 'push',
      component: r => require.ensure([], () => r(require('@/view/data/push-detail/index')), 'push'),
      meta: {
        requireLogin: true
      }
    },
    {
      path: '/ucenter',
      name: 'ucenter',
      component: r => require.ensure([], () => r(require('@/view/ucenter/index')), 'index'),
      meta: {
        requireLogin: true
      }
    },{
      path: "/404",
      name: "notFound",
      component: r => require.ensure([], () => r(require('@/view/home/404')), 'index'),
      }, {
      path: "*", // 此处需特别注意置于最底部
      redirect: "/404"
      }
  ],
  mode: routerMode,
  strict: process.env.NODE_ENV !== 'production',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return {
        x: 0,
        y: to.meta.savedPosition || 0
      }
    }
  },
})




// WEBPACK FOOTER //
// ./src/router/index.js